<template>
  <div>
    <div>
      <div class="seth-set bg-primary">
        <div class="absolute top-0 py-10 w-full px-6 flex">
          <div>
            <p
              @click="handleBack"
              class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
            >
              <feather-icon
                class="flex"
                icon="ArrowLeftIcon"
                svgClasses="w-6 h-6"
              />
              Go Back
            </p>
            <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
              Create A Whatsapp Campaign
            </h2>
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="centerDialogVisibletr" width="30%" center>
        <div slot="title" class="bg-primary">
          <h2 class="font-semibold fsize16 text-white">Create New Sender ID</h2>
        </div>
        <div class="flex justify-center items-center">
          <div class="">
            <div>
              <p class="fsize14 font-semibold mb-0 text-black">Phone Number</p>
              <el-input
                placeholder="Please input"
                class="mt-1"
                name="phone"
                v-model="phone"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                v-validate="{ required: true, max: 10, regex: /^[0-9]*$/ }"
                data-vv-validate-on="input|blur"
              ></el-input>
              <p v-if="errors.has('phone')" class="text-danger mt-1 fsize12">
                {{ errors.first("phone") }}
              </p>
            </div>
            <div class="mt-2">
              <p class="fsize14 font-semibold mb-0 text-black">Bot Name</p>
              <el-input
                placeholder="Please input"
                class="mt-1"
                name="botName"
                v-model="botName"
                v-validate="{ required: true, min: 2, regex: /^[A-Za-z]+$/ }"
                data-vv-validate-on="input|blur"
                @input="checkAplhabet"
              ></el-input>
              <p v-if="errors.has('botName')" class="text-danger fsize12 mt-1">
                {{ errors.first("botName") }}
              </p>
            </div>
            <div class="mt-2">
              <p class="fsize12 col-4f">
                Our representative will configure your request in next 24-48
                hours. For support, contact
                <span class="text-primary font-semibold"
                  >support@brained.app</span
                >
              </p>
            </div>

            <div class="flex gap-4 justify-center mt-6 items-center">
              <vs-button
                type="primary"
                class="bg-primary w-1/2 rounded-lg text-white font-medium fsize14 py-12px px-6"
                @click="createWhatsappConfig()"
              >
                Submit
              </vs-button>
              <vs-button
                type="secondary"
                class="bg-secondary w-1/2 rounded-lg text-white font-medium fsize14 py-12px px-6"
                @click="close()"
              >
                Cancel
              </vs-button>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div @click="verifyClick()" class="w-full bg-white height-100">
      <el-dialog
        class="ne-oppop"
        width="35%"
        :visible.sync="centerDialogVisiblehhr"
        center
      >
        <div class="bg-primary p-4 flex justify-between items-center">
          <h2 class="text-white fsize14 my-0">Whatsapp Campaign</h2>
          <feather-icon
            icon="XIcon"
            svgClasses="w-4 h-4"
            class="cursor-pointer text-white"
            @click="centerDialogVisiblehhr = false"
          />
        </div>

        <div class="flex justify-center mt-3 pb-4 px-4 w-full items-center">
          <div class="">
            <div class="flex justify-center mb-6">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
                class="new-height"
              />
            </div>
            <div class="text-center">
              <h1 class="fsize20 text-dark font-semibold">
                SenderID has been Successfully submitted
              </h1>
              <p class="fsize14 text-gray my-2">
                Please Callback after 24 hours after submission
              </p>
              <vs-button
                color="success"
                class="px-4 mt-2 bg-success border-0 text-white font-normal fsize14"
              >
                <a href="https://gupshup.io" class="text-white" target="_blank"
                  >Click here to setup</a
                >
              </vs-button>
              <p class="cursor-pointer mt-3 mb-4">
                Is your whatsapp already setup?<a
                  @click="
                    () => {
                      centerDialogVisibletr = true;
                      centerDialogVisiblehhr = false;
                      errors.clear();
                      // newSenderIdPopup = true;
                    }
                  "
                  >click here</a
                >
              </p>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        class="ne-oppop"
        width="75%"
        :visible.sync="whatsapppop"
        center
      >
        <div class="bg-primary p-4 flex justify-between items-center">
          <h2 class="text-white fsize14 my-0">Whatsapp Campaign</h2>
          <feather-icon
            icon="XIcon"
            svgClasses="w-4 h-4"
            class="cursor-pointer text-white"
            @click="whatsapppop = false"
          />
        </div>

        <div
          v-if="whatsapppop"
          class="grid grid-cols-3 gap-4 mt-3 pb-4 px-4 w-full items-start"
        >
          <div class="p-3">
            <h2 class="text-black fsize14 my-0">Skeleton View</h2>
            <div class="relative text-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/whatsapp.svg"
                alt="sms"
                class="width-whatsapp mx-auto"
              />
              <div
                class="absolute top-0 left-0 mx-auto right-0 width-whatsapps flex justify-center items-end"
              >
                <div class="rounded-12px wid-230px">
                  <div>
                    <div class="text-center">
                      <small class="text-646464">{{ dateFormat }}</small>
                    </div>
                    <div
                      class="mt-2 rounded-10px bg-white py-2 px-3 tag mr-1 ml-auto"
                    >
                      <p
                        v-if="smsbody && smsbody.variableHeader"
                        v-html="smsbody.variableHeader"
                      ></p>
                      <div v-if="smsbody && smsbody.mediaType == 'image'">
                        <!-- <img
                        :src="
                          smsbody && smsbody.media
                            ? $imageURL + '/' + smsbody.media
                            : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                        "
                        class="w-full h-110px object-cover"
                        alt="image"
                      /> -->
                        <img
                          :src="$imageURL + '/' + smsbody.media"
                          class="w-full h-110px object-cover"
                          alt="image"
                        />
                      </div>
                      <div v-if="smsbody && smsbody.mediaType == 'video'">
                        <video
                          :src="
                            smsbody && smsbody.media
                              ? $imageURL + smsbody.media
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        ></video>
                      </div>
                      <div v-if="smsbody && smsbody.mediaType == 'file'">
                        <iframe
                          :src="
                            smsbody && smsbody.media
                              ? $imageURL + smsbody.media
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        ></iframe>
                      </div>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType == 'interactive'
                        "
                        class="wid-200px"
                        v-html="
                          bodyReplacer(
                            smsbody && smsbody.format
                              ? smsbody.format.split('|')[0]
                              : ''
                          )
                        "
                      ></p>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType == 'variable' &&
                          smsbody.headerVariable.variableHeader
                        "
                        class="wid-200px"
                        v-html="smsbody.headerVariable.variableHeader"
                      ></p>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType == 'variable'
                        "
                        class="wid-200px"
                        v-html="skeletonShow(smsbody.format)"
                      ></p>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType !== 'variable' &&
                          smsbody.mediaType !== 'interactive'
                        "
                        class="wid-200px"
                        v-html="
                          bodyReplacer(
                            smsbody && smsbody.format ? smsbody.format : ''
                          )
                        "
                      ></p>

                      <!-- <p v-if="smsbody">{{ smsbody }}</p> -->

                      <p
                        v-if="!smsbody && !smsbody.format"
                        class="text-black fsize12 p wid-230px"
                      >
                        {{
                          "Note:You can use dynamic tags to fetch info like names,companies & contact info."
                        }}
                        <br />
                        <a href="https://projectbrained.app/asjahfo.in"
                          >https://projectbrained.app/asjahfo</a
                        >
                      </p>
                      <div class="text-right mt-1">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                      <div v-if="smsbody && smsbody.buttonTitle" class="shop">
                        <p class="text-primary fsize12 txt-center">
                          {{
                            smsbody && smsbody.buttonTitle
                              ? smsbody.buttonTitle
                              : ""
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-3">
            <h2 class="text-black fsize14 my-0">Dynamic View</h2>
            <div class="relative text-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/whatsapp.svg"
                alt="sms"
                class="width-whatsapp mx-auto"
              />
              <div
                class="absolute top-0 left-0 mx-auto right-0 width-whatsapps flex justify-center items-end"
              >
                <div class="rounded-12px wid-230px">
                  <div>
                    <div class="text-center">
                      <small class="text-646464">{{ dateFormat }}</small>
                    </div>
                    <div
                      class="mt-2 rounded-10px bg-white py-2 px-3 tag mr-1 ml-auto"
                    >
                      <p
                        v-if="smsbody && smsbody.variableHeader"
                        v-html="smsbody.variableHeader"
                      ></p>
                      <div v-if="smsbody && smsbody.mediaType == 'image'">
                        <!-- <img
                        :src="
                          smsbody && smsbody.media
                            ? $imageURL + '/' + smsbody.media
                            : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                        "
                        class="w-full h-110px object-cover"
                        alt="image"
                      /> -->
                        <img
                          :src="$imageURL + '/' + smsbody.media"
                          class="w-full h-110px object-cover"
                          alt="image"
                        />
                      </div>
                      <div v-if="smsbody && smsbody.mediaType == 'video'">
                        <video
                          :src="
                            smsbody && smsbody.media
                              ? $imageURL + smsbody.media
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        ></video>
                      </div>
                      <div v-if="smsbody && smsbody.mediaType == 'file'">
                        <iframe
                          :src="
                            smsbody && smsbody.media
                              ? $imageURL + smsbody.media
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        ></iframe>
                      </div>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType == 'interactive'
                        "
                        class="wid-200px"
                        v-html="
                          bodyReplacer(
                            smsbody && smsbody.format
                              ? smsbody.format.split('|')[0]
                              : ''
                          )
                        "
                      ></p>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType == 'variable' &&
                          smsbody.headerVariable.variableHeader
                        "
                        class="wid-200px"
                        v-html="editableHeader"
                      ></p>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType == 'variable'
                        "
                        class="wid-200px"
                        v-html="editableBody"
                      ></p>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType !== 'variable' &&
                          smsbody.mediaType !== 'interactive'
                        "
                        class="wid-200px"
                        v-html="
                          bodyReplacer(
                            smsbody && smsbody.format ? smsbody.format : ''
                          )
                        "
                      ></p>

                      <!-- <p v-if="smsbody">{{ smsbody }}</p> -->

                      <p
                        v-if="!smsbody && !smsbody.format"
                        class="text-black fsize12 p wid-230px"
                      >
                        {{
                          "Note:You can use dynamic tags to fetch info like names,companies & contact info."
                        }}
                        <br />
                        <a href="https://projectbrained.app/asjahfo.in"
                          >https://projectbrained.app/asjahfo</a
                        >
                      </p>
                      <div class="text-right mt-1">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                      <div v-if="smsbody && smsbody.buttonTitle" class="shop">
                        <p class="text-primary fsize12 txt-center">
                          {{
                            smsbody && smsbody.buttonTitle
                              ? smsbody.buttonTitle
                              : ""
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-3 grid grid-cols-1 mt-5 gap-6">
            <h2 v-if="smsbody.headerVariable" class="text-black fsize14 my-0">
              Header Variable
            </h2>
            <div v-if="smsbody.headerVariable" class="flex w-full gap-3">
              <div class="w-3/12">
                <el-input
                  disabled
                  placeholder="Please input"
                  v-model="smsbody.headerVariable.variableHeader"
                ></el-input>
              </div>
              <div class="w-9/12">
                <el-select
                  filterable
                  v-model="custHVariableValue"
                  @change="editableHeader = custHVariableValue"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in variableValues"
                    :key="item._id"
                    :label="item.variableName"
                    :value="item.variableBody"
                  >
                  </el-option>
                </el-select>
                <p
                  class="text-ff3131 fsize9 my-0"
                  v-if="varerror && custHVariableValue == ''"
                >
                  This Field is Required
                </p>
              </div>
            </div>
            <h2 class="text-black fsize14 my-0">Body Variables</h2>
            <div
              class="flex w-full gap-3"
              v-for="(variable, index) in smsbody.variables"
              :key="index"
            >
              <div class="w-3/12">
                <el-input
                  disabled
                  placeholder="Please input"
                  v-model="variable.varRef"
                ></el-input>
              </div>
              <div class="w-9/12">
                <el-select
                  filterable
                  v-model="replaceBodyValue[index]"
                  @change="variablereplacer(variable.varRef, index)"
                  placeholder="Select"
                >
                  <el-option
                    v-for="item in variableValues"
                    :key="item._id"
                    :label="item.variableName"
                    :value="item.variableBody"
                  >
                  </el-option>
                </el-select>
                <p
                  class="text-ff3131 fsize9 my-0"
                  v-if="varerror && !replaceBodyValue[index]"
                >
                  This Field is Required
                </p>
              </div>
            </div>
            <div class="flex justify-end mt-2 gap-3">
              <vs-button
                @click="assignModified()"
                class="bgprimary fsize18 px-2 py-1"
                >Save</vs-button
              >
              <vs-button
                @click="whatsapppop = false"
                class="bgprimary fsize18 px-2 py-1"
                >Cancel</vs-button
              >
            </div>
          </div>
        </div>
      </el-dialog>

      <!-- <el-dialog :visible.sync="centerDialogVisibletr" width="30%" center>
      <div slot="title" class="bg-primary">
        <h2 class="font-semibold fsize16 text-white">Add New Segment</h2>
      </div>
      <div class="flex justify-center items-center">
        <div class="">
          <div>
            <p class="fsize14 font-semibold mb-0 text-black">Phone Number</p>
            <el-input
              placeholder="Please input"
              class="mt-1"
              name="phone"
              v-model="phone"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              v-validate="{ required: true, max: 10, regex: /^[0-9]*$/ }"
              data-vv-validate-on="input|blur"
            ></el-input>
            <p v-if="errors.has('phone')" class="text-danger mt-1 fsize12">
              {{ errors.first("phone") }}
            </p>
          </div>
          <div class="mt-2">
            <p class="fsize14 font-semibold mb-0 text-black">Bot Name</p>
            <el-input
              placeholder="Please input"
              class="mt-1"
              name="botName"
              v-model="botName"
              v-validate="{ required: true, min: 2, regex: /^[A-Za-z]+$/ }"
              data-vv-validate-on="input|blur"
              @input="checkAplhabet"
            ></el-input>
            <p v-if="errors.has('botName')" class="text-danger fsize12 mt-1">
              {{ errors.first("botName") }}
            </p>
          </div>
          <div class="mt-2">
            <p class="fsize12 col-4f">
              Our representative will configure your request in next 24-48
              hours. For support, contact
              <span class="text-primary font-semibold"
                >support@brained.app</span
              >
            </p>
          </div>

          <div class="flex gap-4 justify-center mt-6 items-center">
            <vs-button
              type="primary"
              class="bg-primary w-1/2 rounded-lg text-white font-medium fsize14 py-12px px-6"
              @click="createWhatsappConfig()"
            >
              Submit
            </vs-button>
            <vs-button
              type="secondary"
              class="bg-secondary w-1/2 rounded-lg text-white font-medium fsize14 py-12px px-6"
              @click="
                () => {
                  centerDialogVisibletr = false;
                  // centerDialogVisiblehhr = true;
                }
              "
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog> -->
      <el-dialog
        :visible.sync="centerDialogVisible"
        width="30%"
        center
        class="hidedialog ishidePopup"
      >
        <div class="flex justify-center items-center">
          <div>
            <div class="flex justify-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
                class="w-32 h-32"
              />
            </div>

            <div class="text-center mt-4">
              <h4 class="font-semibold text-dark text-2xl">
                You Need more WhatsApp Credits
              </h4>
              <p class="fsize12 text-black pt-1">
                The Campaign is set to target
                <span class="text-primary font-semibold"> 1000</span> audience.
                need <span class="text-primary font-semibold"> 100</span> more
                WhatsApp credits to run this Campaign
              </p>
            </div>
            <div class="flex gap-4 justify-center mt-6 items-center">
              <vs-button
                type="success"
                class="bg-success rounded-full text-white font-medium fsize14 py-12px px-6"
                @click="handleClick('Add-ons')"
              >
                By more WhatsApp credits
              </vs-button>
              <vs-button
                type="primary"
                @click="centerDialogVisible = false"
                class="bg-primary rounded-full text-white font-medium fsize14 py-12px px-6"
              >
                Edit Target audience
              </vs-button>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="isShowCampaignPopup"
        custom-class="ishidePopup"
        width="30%"
        center
      >
        <div class="">
          <div class="block">
            <div>
              <span class="demonstration text-dark font-semibold"
                >Pick a Date & Time</span
              >
            </div>
            <el-date-picker
              v-model="datepick"
              type="date"
              placeholder="Pick a date"
              class="mt-3 w-full"
            >
            </el-date-picker>
          </div>
          <p class="text-8f8f8f fsize12 mt-2">
            You can alwys change the schedule later by visting your planner
            before the event goes live.
          </p>

          <el-divider class="text-primary font-semibold">OR</el-divider>
          <div>
            <div class="flex items-center">
              <input type="checkbox" class="cust-check" />
              <p class="pl-2 mb-0 text-dark font-semibold">
                Start it Instantly
              </p>
            </div>
            <p class="text-8f8f8f fsize12 mt-1">
              Link a specific page or a website you'd like to inclide in your
              campaign
            </p>
          </div>

          <div class="flex gap-4 justify-center mt-6 items-center">
            <vs-button
              type="primary"
              class="bg-primary w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
            >
              Confirm Campaign
            </vs-button>
            <vs-button
              type="secondary"
              class="bg-secondary w-1/2 rounded-full text-white font-medium fsize14 py-12px px-6"
              @click="isShowCampaignPopup = false"
            >
              Cancel
            </vs-button>
          </div>
        </div>
      </el-dialog>
      <!-- <el-dialog
      class="ne-oppop"
      width="35%"
      :visible.sync="centerDialogVisiblehh"
      center
      :close-on-click-modal="options.length > 1 ? true : false"
    >
      <div class="bg-primary p-4 flex justify-between items-center">
        <h2 class="text-white fsize14 my-0">Whatsapp Campaign</h2>
        <feather-icon
          icon="XIcon"
          svgClasses="w-4 h-4"
          class="cursor-pointer text-white"
          @click="
            () => {
              this.$router.push({ path: '/admin-panel/marcom' });
            }
          "
        />
      </div>

      <div class="flex justify-center mt-3 pb-4 px-4 w-full items-center">
        <div class="">
          <div class="flex justify-center mb-6">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
              class="new-height"
            />
          </div>
          <div class="text-center">
            <h1 class="fsize20 text-dark font-semibold">
              SenderID has been Succsefully submitted
            </h1>
            <p class="fsize14 text-gray my-2">
              Please Callback after 24 hours after submission
            </p>
            <vs-button
              color="success"
              class="px-4 mt-2 bg-success border-0 text-white font-normal fsize14"
            >
              <a href="https://gupshup.io" class="text-white" target="_blank"
                >Click here to setup</a
              >
            </vs-button>
            <p class="cursor-pointer">
              Is your whatsapp already setup?<a
                @click="
                  () => {
                    centerDialogVisiblehh = false;
                    centerDialogVisibletr = true;
                  }
                "
                >click here</a
              >
            </p>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="" width="35%" center>
      <template slot="title"
        ><h2 class="text-white fsize14">Whatsapp Campaign</h2></template
      >
      <div class="flex justify-center w-full items-center">
        <div class="">
          <div class="flex justify-center mb-6">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
              class="new-height"
            />
          </div>
          <div class="text-center">
            <h1 class="fsize20 text-dark font-semibold">
              Create an Whatsapp Campaign
            </h1>
            <p class="fsize14 text-gray my-2">
              For this you need to setup Whatsapp Campaign.
            </p>
            <vs-button
              color="success"
              class="px-4 mt-2 bg-success border-0 text-white font-normal fsize14"
            >
              <a
                href="https://www.gupshup.io"
                class="text-white"
                target="_blank"
                >Click here to setup</a
              >
            </vs-button>
            <p>Is your Whatsapp already setup ? <a>click here</a></p>
          </div>
        </div>
      </div>
    </el-dialog> -->

      <!-- <div class="seth-set bg-primary">
        <div class="absolute top-0 py-10 w-full px-6 flex">
          <div>
            <p
              @click="handleBack"
              class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
            >
              <feather-icon
                class="flex"
                icon="ArrowLeftIcon"
                svgClasses="w-6 h-6"
              />
              Go Back
            </p>
            <h2 class="text-white pt-1 text-2xl capitalize font-semibold">
              Create A Whatsapp Campaign
            </h2>
          </div>
        </div>
      </div> -->
      <div class="bg-white px-6 py-8 menucontrol-scroll fixed-top">
        <div class="flex w-full">
          <div class="w-2/5 pr-12">
            <div class="relative text-center">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Assets/whatsapp.svg"
                alt="sms"
                class="width-whatsapp mx-auto"
              />
              <div
                class="absolute top-0 left-0 mx-auto right-0 width-whatsapps flex justify-center items-end"
              >
                <div class="rounded-12px wid-230px">
                  <div>
                    <div class="text-center">
                      <small class="text-646464">{{ dateFormat }}</small>
                    </div>
                    <!-- <el-popover v-model="popover" placement="top" width="300">
                    <p>Please customize your content before proceeding</p>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        size="mini"
                        type="text"
                        @click="popover = false"
                        >OK</el-button
                      >
                    </div>
                  </el-popover> -->
                    <div
                      v-if="smsbody.variableType == true && !popover"
                      class="flex justify-end mt-2"
                    >
                      <vs-button
                        class="bgprimary fsize12 px-2 py-1"
                        @click="whatsapppop = true"
                        >Customize</vs-button
                      >
                    </div>
                    <div
                      v-if="smsbody.variableType == true && popover"
                      :class="{ magnify: magnify }"
                    >
                      <vs-button
                        class="bgprimary fsize12 px-2 py-1"
                        @click="(whatsapppop = true), (popover = false)"
                        >Please customize your content before proceeding
                      </vs-button>
                    </div>
                    <div
                      class="mt-2 rounded-10px bg-white py-2 px-3 tag mr-1 ml-auto"
                    >
                      <!-- <p
                      v-if="smsbody && smsbody.variableHeader"
                      v-html="smsbody.variableHeader"
                    ></p> -->
                      <div v-if="smsbody && smsbody.mediaType == 'image'">
                        <!-- <img
                        :src="
                          smsbody && smsbody.media
                            ? $imageURL + '/' + smsbody.media
                            : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                        "
                        class="w-full h-110px object-cover"
                        alt="image"
                      /> -->
                        <img
                          :src="$imageURL + '/' + smsbody.media"
                          class="w-full h-110px object-cover"
                          alt="image"
                        />
                      </div>
                      <div v-if="smsbody && smsbody.mediaType == 'video'">
                        <video
                          :src="
                            smsbody && smsbody.media
                              ? $imageURL + smsbody.media
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        ></video>
                      </div>
                      <div v-if="smsbody && smsbody.mediaType == 'file'">
                        <iframe
                          :src="
                            smsbody && smsbody.media
                              ? $imageURL + smsbody.media
                              : 'https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png'
                          "
                          class="w-full h-110px object-cover"
                          alt="image"
                        ></iframe>
                      </div>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType == 'interactive'
                        "
                        class="wid-200px"
                        v-html="
                          bodyReplacer(
                            smsbody && smsbody.format
                              ? smsbody.format.split('|')[0]
                              : ''
                          )
                        "
                      ></p>
                      <!-- <p
                      v-if="
                        smsbody &&
                        smsbody.format &&
                        smsbody.mediaType == 'variable'
                      "
                      class="wid-200px"
                      v-html="Replacer(smsbody)"
                    ></p> -->
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType == 'variable'
                        "
                        class="wid-200px"
                        v-html="concat"
                      ></p>
                      <p
                        v-if="
                          smsbody &&
                          smsbody.format &&
                          smsbody.mediaType !== 'variable' &&
                          smsbody.mediaType !== 'interactive'
                        "
                        class="wid-200px"
                        v-html="
                          bodyReplacer(
                            smsbody && smsbody.format ? smsbody.format : ''
                          )
                        "
                      ></p>

                      <!-- <p v-if="smsbody">{{ smsbody }}</p> -->

                      <p
                        v-if="!smsbody && !smsbody.format"
                        class="text-black fsize12 p wid-230px"
                      >
                        {{
                          "Note:You can use dynamic tags to fetch info like names,companies & contact info."
                        }}
                        <br />
                        <a href="https://projectbrained.app/asjahfo.in"
                          >https://projectbrained.app/asjahfo</a
                        >
                      </p>
                      <div class="text-right mt-1">
                        <small class="text-646464">{{ timeFormat }}</small>
                      </div>
                      <div v-if="smsbody && smsbody.buttonTitle" class="shop">
                        <p class="text-primary fsize12 txt-center">
                          {{
                            smsbody && smsbody.buttonTitle
                              ? smsbody.buttonTitle
                              : ""
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p class="fsize12 col-4f mt-4 text-center">
              Note: The appearence of the text message may vary <br />based on
              the style preference on diffrent device.
            </p>
          </div>
          <div class="w-3/5 bg-white relative">
            <div class="grid grid-cols-2 gap-8">
              <div>
                <div class="">
                  <h6 class="col-4f text-xl mb-1 font-semibold">
                    Give a title to this Campaign
                  </h6>
                  <p class="text-8f8f8f fsize12 mb-0">
                    This title is just for your personal refrence
                  </p>
                  <el-input
                    placeholder="Please input"
                    class="mt-3 w-full"
                    v-model="input"
                  ></el-input>

                  <p
                    v-if="submitted == true || checkform1 === true"
                    class="fsize12 text-danger"
                  >
                    {{
                      input === "" || input[0].trim() === ""
                        ? "This Field is required"
                        : ""
                    }}
                  </p>
                </div>
                <div class="mt-6">
                  <h6 class="col-4f text-xl mb-1 font-semibold">
                    Select Sender Id
                  </h6>
                  <p class="text-8f8f8f fsize12 mb-0">
                    Registered whatsapp number
                  </p>
                  <el-select
                    v-model="value1"
                    placeholder="Select Sender ID"
                    class="w-full mt-3"
                    value-key="_id"
                  >
                    <!-- <el-option label="Create Sender Id" value="Create Sender Id">
                  </el-option> -->
                    <el-option
                      v-for="item in options"
                      :key="item._id"
                      :label="item.source"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <p
                    v-if="submitted == true || checkform1 === true"
                    class="fsize12 text-danger"
                  >
                    {{ value1 === "" ? "This Field is required" : "" }}
                  </p>
                </div>
                <div class="mt-4 w-full">
                  <p
                    class="w-full text-success flex items-center gap-2 cursor-pointer text-white font-semibold fsize14"
                    @click="
                      () => {
                        centerDialogVisibletr = true;
                      }
                    "
                  >
                    <feather-icon icon="PlusIcon" svgClasses="w-5 h-5" />Create
                    New SenderID
                  </p>
                </div>
                <div class="mt-6">
                  <h6 class="col-4f text-xl mb-1 font-semibold">
                    Select Template
                  </h6>
                  <p class="text-8f8f8f fsize12 mb-0">Select a Template</p>
                  <el-select
                    filterable
                    v-model="smsbody"
                    placeholder="Select"
                    class="w-full new-selece mt-2"
                    popper-class="selectdrop-set"
                    value-key="_id"
                    :disabled="!value1"
                  >
                    <el-option
                      v-for="item in data.data"
                      :key="item._id"
                      :label="item.label"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <p
                    v-if="submitted == true || checkform1 === true"
                    class="fsize12 text-danger"
                  >
                    {{ smsbody === "" ? "This Field is required" : "" }}
                  </p>
                  <el-divider>or</el-divider>
                  <p
                    @click="wayto()"
                    class="w-full mt-2 text-success flex items-center gap-2 justify-start cursor-pointer text-white font-semibold fsize14"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="flex"
                      svgClasses="w-5 h-5"
                    />Create New Template
                  </p>
                </div>
              </div>
              <div>
                <div class="">
                  <h6 class="col-4f text-xl mb-1 font-semibold">
                    Select Target Segment
                  </h6>
                  <p class="text-8f8f8f fsize12 mb-0">
                    Select the target audience segment for this Campaign
                  </p>
                  <el-select
                    filterable
                    v-model="value"
                    placeholder="Select"
                    multiple
                    class="w-full mt-2"
                    value-key="_id"
                  >
                    <el-option
                      v-for="item in segments"
                      :key="item._id"
                      :label="item.name"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                  <p
                    v-if="submitted == true || checkform1 === true"
                    class="fsize12 text-danger"
                  >
                    {{ value.length === 0 ? "This Field is required" : "" }}
                  </p>
                </div>
                <el-divider>or</el-divider>
                <div class="mt-2 mb-8">
                  <div
                    @click="ShowNewSegment()"
                    class="rounded-md gap-2 cursor-pointer"
                  >
                    <div class="flex items-center gap-2">
                      <feather-icon icon="PlusIcon" class="text-success flex" />
                      <p class="text-success fsize14 mb-0 font-semibold">
                        Create new Segment
                      </p>
                    </div>
                  </div>
                </div>
                <el-dialog
                  title=""
                  :visible.sync="isShowNewSegment"
                  width="50%"
                  class=""
                  center
                >
                  <div slot="title" class="bg-primary">
                    <h2 class="font-semibold fsize16 text-white">
                      Add New Segment
                    </h2>
                  </div>
                  <div class="">
                    <AddSegmentTable
                      @handleAddNewSegment="handleAddNewSegment"
                    />
                  </div>
                </el-dialog>
                <div class="flex justify-between w-full mt-2">
                  <div class="flex gap-2 items-center">
                    <p class="col-4f fsize12 font-medium">TG Size:</p>
                    <p class="text-primary fsize12 font-semibold">
                      {{ count }}
                    </p>
                  </div>
                  <div class="flex gap-2 items-center">
                    <p class="col-4f fsize12 font-medium">Whatsapp Credits:</p>
                    <p class="text-primary fsize12 font-semibold">
                      {{ myAddonsData ? myAddonsData.quantity.toFixed(2) : 0 }}
                    </p>
                  </div>
                </div>
                <div
                  class="mt-6 bg-f4f5f6 p-4 rounded-6px w-full"
                  v-if="this.myAddonsData.quantity <= 100"
                >
                  <h3 class="font-semibold col-4f text-xl">Resources</h3>
                  <div class="flex items-center mt-4">
                    <div class="flex gap-2 items-center">
                      <img
                        src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/Ecom/sms.svg"
                        class="object-contain"
                        alt="banh"
                      />

                      <div class="mt-2 pl-4">
                        <h2 class="font-semibold mb-0 col-4f text-lg">
                          x 3000 WhatsApp Credits
                        </h2>
                        <p class="fsize12 mt-0 col-4f">
                          You have WhatsApp Credits
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="w-full mt-4">
                    <vs-button
                      color="success"
                      @click="handleClick('Add-ons')"
                      class="w-full bg-success border-0 text-white font-normal fsize14"
                    >
                      Buy More
                    </vs-button>
                  </div>
                </div>
                <!-- <div class="mt-6">
                <h6 class="col-4f text-2xl mb-0">Pick a Template</h6>
                <p class="text-8f8f8f fsize12 mb-0">
                  Select a layout for your email
                </p>
                <div class="grid grid-cols-2 gap-4 mt-2">
                  <div>
                    <img
                      src="@/assets/images/frag.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag2.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag3.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                  <div>
                    <img
                      src="@/assets/images/frag4.png"
                      class="w-full"
                      alt="banhf"
                    />
                  </div>
                </div>
              </div> -->
              </div>
            </div>
            <div class="absolute margin-nichu right-0">
              <!-- <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/pinkgo.png"
                class=""
              /> -->
              <!-- @click="handleSubmit()" -->
              <div class="bg-primary w-24 h-24 rounded-full cursor-pointer">
                <div
                  class="flex justify-center items-center w-24 h-24"
                  @click="handleSubmit()"
                >
                  <feather-icon
                    icon="ArrowRightIcon"
                    svgClasses="w-10 h-10"
                    class="text-white flex"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VueEllipseProgress from "vue-ellipse-progress";
import { mapState } from "vuex";
import { VueEditor } from "vue2-quill-editor";
import AddSegmentTable from "../../../../segment/components/AddSegmentTable.vue";
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      custHVariableRef: "",
      custHVariableValue: "",
      variableValues: [],
      custVariableValues: [],
      count: 0,
      segmentData: [],
      data: [],
      whatsapppop: false,
      popupnew: false,
      centerDialogVisible: false,
      centerDialogVisibletr: false,
      centerDialogVisiblehh: false,
      centerDialogVisiblehhr: false,
      textarea2: "",
      input: "",
      isShowCampaignPopup: false,
      value: "",
      value1: "",
      smsbody: "",
      isShowNewSegment: false,
      options: [],
      show: false,
      mobile: "",
      submitted: false,
      checkform1: "",
      botName: "",
      phone: "",
      datepick: "",
      input: "",
      myAddonsData: [],
      concat: "",
      editableBody: "",
      editableHeader: "",
      replaceBodyValue: [],
      isshowform: false, // only added for create template pop up
      templateName: "", // only added for create template pop up
      templateTypeOptions: [], // only added for create template pop up
      MediaTypeOptions: [], // only added for create template pop up
      buttonselect: [], // only added for create template pop up
      varerror: false,
      popover: false,
      magnify: false,
    };
  },
  components: {
    AddSegmentTable,
    VueEditor,
  },

  methods: {
    verifyClick() {
      // console.log(data);
      // if (this.options.length > 0 && data == true) {
      //   this.centerDialogVisibletr = false;
      // } else {
      //   this.phone = "";
      //   this.botName = "";
      //   this.centerDialogVisibletr = true;
      //   this.$validator.reset();
      // }
      if (this.options.length > 0) {
        this.centerDialogVisibletr = false;
      }
      if (this.options.length == 0) {
        this.centerDialogVisibletr = true;
        this.phone = "";
        this.botName = "";
        this.centerDialogVisibletr = true;
        this.$validator.reset();
      }
    },

    assignModified() {
      this.varerror = true;
      if (
        this.replaceBodyValue.length == this.smsbody.variables.length &&
        this.custHVariableValue
      ) {
        let body = {
          variableType: true,
          variable: this.editableHeader,
          format: this.editableBody,
        };
        this.Replacer(body);
        this.whatsapppop = false;
      }
    },
    variablereplacer(ref, index) {
      if (this.editableBody.includes(ref)) {
        this.editableBody = this.editableBody.replace(
          ref,
          this.replaceBodyValue[index]
        );
      } else {
        this.editableBody = this.smsbody.format.replaceAll("\n", "<br>");
        for (let i = 0; i < this.replaceBodyValue.length; i++) {
          this.editableBody = this.editableBody.replace(
            `{{${i + 1}}}`,
            this.replaceBodyValue[i]
          );
        }
      }
    },
    skeletonShow(body) {
      // console.log("skeletonShow");
      return body.replaceAll("\n", "<br>");
    },
    checkAplhabet(event) {
      this.botName = this.botName.replace(/[0-9!@#$%^&*()_+-=~]/g, "");
    },

    async createSmsConfig() {
      await this.$store.dispatch("smsCampaign/createSmsConfig", {
        mobile: this.mobile,
        projectId: this.selectedProject._id,
      });
    },
    downloadPdf() {
      this.createSmsConfig();
      window.open(`${this.$imageURL}/brained/admin/sms_setup/SMS%20Setup.zip`);
      this.show = false;
    },
    handleAddNewSegment() {
      this.isShowNewSegment = false;
    },
    wayto() {
      if (this.options.length > 0) {
        this.$router.push({ name: "template-Whatsappcampaign" });
      } else {
        this.centerDialogVisibletr = true;
        this.phone = "";
        this.botName = "";
        this.centerDialogVisibletr = true;
        this.$validator.reset();
      }
    },
    ShowNewSegment() {
      if (this.options.length > 0) {
        this.isShowNewSegment = true;
      } else {
        this.centerDialogVisibletr = true;
        this.phone = "";
        this.botName = "";
        this.centerDialogVisibletr = true;
        this.$validator.reset();
      }
    },
    async handleSubmit() {
      // centerDialogVisible = true
      this.submitted = true;
      let test = this.concat.match(/{{(\d+)}}/g);
      test = test == null ? (test = []) : test;
      // if (this.myAddonsData.toFixed(2) > this.count) {
      if (this.myAddonsData > this.count) {
        this.centerDialogVisible = true;
      } else if (this.smsbody.variableType == true) {
        if (
          this.input != "" &&
          this.value1 != "" &&
          test.length == 0 &&
          this.value.length != 0
        ) {
          let userData = [];
          for (let i = 0; i < this.value.length; i++) {
            for (let j = 0; j < this.value[i].audienceId.length; j++) {
              userData.push({
                _id: this.value[i].audienceId[j]._id,
                mobile: this.value[i].audienceId[j].mobile
                  ? this.value[i].audienceId[j].mobile
                  : this.value[i].audienceId[j].contact,
              });
            }
          }

          let filtered = userData.filter(function ({ _id, mobile }) {
            let key = `${_id}${mobile}`;
            return !this.has(key) && this.add(key);
          }, new Set());
          this.$swal
            .fire({
              title: "Alert",
              text: `Are you sure you want to proceed with the selected data, Selected Template will be sent to ${
                filtered.length == 1
                  ? "1 user"
                  : filtered.length + " " + "users"
              }`,
              icon: "warning",
              confirmButtonText: "Yes, Continue",
              cancelButtonText: "Cancel",
              showCancelButton: true,
              confirmButtonColor: "#EA4Dff",
              cancelButtonColor: "  #6e7881",
            })
            .then(async (result) => {
              if (result.isConfirmed) {
                let payload = {
                  destination: filtered,
                  sender: this.value1,
                  type: this.smsbody.mediaType,
                  // message: this.smsbody.format,
                  name: this.input,
                  createdBy: { _user: this.login._id },
                };

                if (this.smsbody.mediaType == "text") {
                  let message = this.smsbody.format.replaceAll("\\n", "\n");
                  Object.assign(payload, {
                    message: message,
                    // message: this.smsbody.format.replaceAll("\\n", "\n"),
                  });
                }
                if (this.smsbody.mediaType == "variable") {
                  Object.assign(payload, {
                    message: this.concat.replaceAll("<br>", "\n"),
                  });
                }
                if (this.smsbody.mediaType == "interactive") {
                  let message = this.smsbody.format.replaceAll("\\n", "\n");
                  let final = message.replace(/\\"/g, '"');
                  // console.log("final", final);
                  Object.assign(payload, {
                    message: final,
                    // message: this.smsbody.format.replaceAll("\\n", "\n"),
                  });
                }
                if (this.smsbody.mediaType == "image") {
                  Object.assign(payload, {
                    url: this.$imageURL + "/" + this.smsbody.media,
                  });
                  // Object.assign(payload, { url: this.smsbody.media });
                  Object.assign(payload, {
                    message: this.smsbody.format.replaceAll("\\n", "\n"),
                  });
                }
                if (this.smsbody.mediaType == "video") {
                  Object.assign(payload, {
                    url: this.$imageURL + this.smsbody.media,
                  });
                  Object.assign(payload, {
                    message: this.smsbody.format.replaceAll("\\n", "\n"),
                  });
                }
                if (this.smsbody.mediaType == "file") {
                  Object.assign(payload, {
                    url: this.$imageURL + this.smsbody.media,
                  });
                  Object.assign(payload, {
                    message: this.smsbody.format.replaceAll("\\n", "\n"),
                  });
                  Object.assign(payload, {
                    fileName: "Sample01.pdf",
                  });
                }

                // console.log(payload.message);

                let data = await this.$store.dispatch(
                  "whatsApp/create",
                  payload
                );

                if (data.code == 200 && !data.data.code) {
                  this.$swal({
                    title: "Whatsapp Campaign Created Successfully",
                    // text: message,
                    icon: "success",
                    confirmButtonColor: "#830c81",
                    confirmButtonText: "OK",
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.$router.push("my-campaign");
                    }
                  });
                  this.submitted = false;
                  this.value1 = "";
                  this.smsbody = "";
                  this.input = "";
                  this.value = [];
                  this.filtered = [];
                } else {
                  this.$swal({
                    title: "Campaign Name Already Exists",
                    // text: message,
                    icon: "warning",
                    confirmButtonColor: "#830c81",
                    confirmButtonText: "OK",
                  });
                }
              }
            });
        } else {
          this.popover = true;
          this.magnify = true;
          setTimeout(() => {
            this.popover = false;
            this.magnify = false;
          }, 2000);
        }
      } else {
        try {
          if (
            this.input != "" &&
            this.value1 != "" &&
            this.smsbody != "" &&
            this.value.length != 0
          ) {
            let userData = [];
            for (let i = 0; i < this.value.length; i++) {
              for (let j = 0; j < this.value[i].audienceId.length; j++) {
                userData.push({
                  _id: this.value[i].audienceId[j]._id,
                  mobile: this.value[i].audienceId[j].mobile
                    ? this.value[i].audienceId[j].mobile
                    : this.value[i].audienceId[j].contact,
                });
              }
            }

            let filtered = userData.filter(function ({ _id, mobile }) {
              let key = `${_id}${mobile}`;
              return !this.has(key) && this.add(key);
            }, new Set());
            this.$swal
              .fire({
                title: "Alert",
                text: `Are you sure you want to proceed with the selected data, Selected Template will be sent to ${
                  filtered.length == 1
                    ? "1 user"
                    : filtered.length + " " + "users"
                }`,
                icon: "warning",
                confirmButtonText: "Yes, Continue",
                cancelButtonText: "Cancel",
                showCancelButton: true,
                confirmButtonColor: "#EA4Dff",
                cancelButtonColor: "  #6e7881",
              })
              .then(async (result) => {
                if (result.isConfirmed) {
                  let payload = {
                    destination: filtered,
                    sender: this.value1,
                    type: this.smsbody.mediaType,
                    // message: this.smsbody.format,
                    name: this.input,
                    createdBy: { _user: this.login._id },
                  };

                  if (this.smsbody.mediaType == "text") {
                    let message = this.smsbody.format.replaceAll("\\n", "\n");
                    Object.assign(payload, {
                      message: message,
                      // message: this.smsbody.format.replaceAll("\\n", "\n"),
                    });
                  }
                  // if (this.smsbody.mediaType == "variable") {
                  //   Object.assign(payload, {
                  //     message: this.concat.replaceAll("<br>", "\n"),
                  //   });
                  // }
                  if (this.smsbody.mediaType == "interactive") {
                    let message = this.smsbody.format.replaceAll("\\n", "\n");
                    let final = message.replace(/\\"/g, '"');
                    // console.log("final", final);
                    Object.assign(payload, {
                      message: final,
                      // message: this.smsbody.format.replaceAll("\\n", "\n"),
                    });
                  }
                  if (this.smsbody.mediaType == "image") {
                    Object.assign(payload, {
                      url: this.$imageURL + "/" + this.smsbody.media,
                    });
                    // Object.assign(payload, { url: this.smsbody.media });
                    Object.assign(payload, {
                      message: this.smsbody.format.replaceAll("\\n", "\n"),
                    });
                  }
                  if (this.smsbody.mediaType == "video") {
                    Object.assign(payload, {
                      url: this.$imageURL + this.smsbody.media,
                    });
                    Object.assign(payload, {
                      message: this.smsbody.format.replaceAll("\\n", "\n"),
                    });
                  }
                  if (this.smsbody.mediaType == "file") {
                    Object.assign(payload, {
                      url: this.$imageURL + this.smsbody.media,
                    });
                    Object.assign(payload, {
                      message: this.smsbody.format.replaceAll("\\n", "\n"),
                    });
                    Object.assign(payload, {
                      fileName: "Sample01.pdf",
                    });
                  }

                  // console.log(payload.message);

                  let data = await this.$store.dispatch(
                    "whatsApp/create",
                    payload
                  );

                  if (data.code == 200 && !data.data.code) {
                    this.$swal({
                      title: "Whatsapp Campaign Created Successfully",
                      // text: message,
                      icon: "success",
                      confirmButtonColor: "#830c81",
                      confirmButtonText: "OK",
                    }).then((result) => {
                      // if (result.isConfirmed) {
                      //   this.$router.push("my-campaign");
                      // }
                    });
                    this.submitted = false;
                    this.value1 = "";
                    this.smsbody = "";
                    this.input = "";
                    this.value = [];
                    this.filtered = [];
                  } else {
                    this.$swal({
                      title: "Campaign Name Already Exists",
                      // text: message,
                      icon: "warning",
                      confirmButtonColor: "#830c81",
                      confirmButtonText: "OK",
                    });
                  }
                }
              });
            //   let payload = {
            //     destination: filtered,
            //     sender: this.value1,
            //     type: this.smsbody.mediaType,
            //     // message: this.smsbody.format,
            //     name: this.input,
            //     createdBy: { _user: this.login._id },
            //   };

            //   if (this.smsbody.mediaType == "text") {
            //     let message = this.smsbody.format.replaceAll("\\n", "\n");
            //     let final = message.replace(/\\"/g, '"');
            //     // console.log(final);
            //     Object.assign(payload, {
            //       message: final,
            //       // message: this.smsbody.format.replaceAll("\\n", "\n"),
            //     });
            //   }
            //   if (this.smsbody.mediaType == "image") {
            //     Object.assign(payload, {
            //       url: this.$imageURL + "/" + this.smsbody.media,
            //     });
            //     // Object.assign(payload, { url: this.smsbody.media });
            //     Object.assign(payload, {
            //       message: this.smsbody.format.replaceAll("\\n", "\n"),
            //     });
            //   }
            //   if (this.smsbody.mediaType == "video") {
            //     Object.assign(payload, {
            //       url: this.$imageURL + "/" + this.smsbody.media,
            //     });
            //     Object.assign(payload, {
            //       message: this.smsbody.format.replaceAll("\\n", "\n"),
            //     });
            //   }
            //   if (this.smsbody.mediaType == "file") {
            //     Object.assign(payload, {
            //       url: this.$imageURL + "/" + this.smsbody.media,
            //     });
            //     Object.assign(payload, {
            //       message: this.smsbody.format.replaceAll("\\n", "\n"),
            //     });
            //     Object.assign(payload, {
            //       fileName: "Sample01.pdf",
            //     });
            //   }

            //   // console.log(payload.message);

            //   let data = await this.$store.dispatch("whatsApp/create", payload);

            //   if (data.code == 200 && !data.data.code) {
            //     this.$swal({
            //       title: "Whatsapp Campaign Created Successfully",
            //       // text: message,
            //       icon: "success",
            //       confirmButtonColor: "#830c81",
            //       confirmButtonText: "OK",
            //     });
            //     this.submitted = false;
            //     this.value1 = "";
            //     this.smsbody = "";
            //     this.input = "";
            //     this.value = [];
            //     this.filtered = [];
            //   } else {
            //     this.$swal({
            //       title: "Campaign Name Already Exists",
            //       // text: message,
            //       icon: "warning",
            //       confirmButtonColor: "#830c81",
            //       confirmButtonText: "OK",
            //     });
            //   }
            // } else {
            //   this.$swal({
            //     text: `Please Fill All fields`,
            //     icon: "info",
            //   });
          } else {
            this.$swal({
              text: `Please Fill All fields`,
              icon: "info",
            });
          }
          // console.log(filtered);
        } catch (err) {
          console.log(err);
        }
        // }
      }
    },
    async getAllSegments() {
      try {
        let data = await this.$store.dispatch("segment/getAllSegment");
        this.segmentData = data.data.registeredUser;
        this.$store.commit("segment/SEGMENT_DATA", this.segmentData);

        // console.log(data);
      } catch (err) {
        console.log(err);
      }
    },
    async createWhatsappConfig() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        source: this.phone,
        name: this.botName,
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        user: this.taskListUsers.PM[0]._id,
      };

      this.$validator.validateAll().then(async (result) => {
        if (result) {
          let data = await axios.post(
            process.env.VUE_APP_BASE_API +
              "marcom/whatsapp/createWhatsappConfig",
            // "http://localhost:3000/api/marcom/whatsapp/createWhatsappConfig",
            payload,
            {
              headers: {
                "community-name": process.env.VUE_APP_COMMUNITY_NAME,
              },
            }
          );
          this.$swal({
            text: "Whatsapp SenderID Successfully Created",
            icon: "success",
            confirmButtonColor: "#830c81",
            // cancelButtonColor: "#d33",
            confirmButtonText: "Okay",
          });
          this.centerDialogVisibletr = false;
          console.log(data, "success");
        }
      });
    },
    handleClick(name) {
      this.$router.push({ name: name });
      // @click="handleClick('marcom-Whatsappcampaign-complete')"
    },
    close() {
      this.centerDialogVisibletr = false;
    },
    bodyReplacer(text) {
      // console.log(text);
      let data = text.replaceAll("\\n", "\n");
      return data;

      // return
    },
    Replacer(body) {
      let varData;

      if (body.variableType == true) {
        let hmsg = body.variable
          ? body.variable
          : body.headerVariable.variableHeader;
        let bmsg = body.format;

        // varData = await this.$store.dispatch("variable/getMultiple", {
        //   variables: body.variables,
        // });
        // console.log("varData", varData);

        // if (hmsg && hmsg.includes("{{1}}")) {
        //   hmsg.replace("{{1}}", body.headerVariable.variableHeaderValue);
        // }
        // if (bmsg.includes("{{1}}")) {
        //   for (let i = 0; i < body.variables.length; i++) {
        //     bmsg = bmsg.replace(
        //       body.variables[i].varRef,
        //       body.variables[i].varValue
        //     );
        //   }
        //   // for (let i = 0; i < varData.data.length; i++) {
        //   //   bmsg = bmsg.replace(
        //   //     varData.data[i].varRef,
        //   //     varData.data[i].varValue
        //   //   );
        //   // }
        // }
        let data = hmsg + "\n" + bmsg;
        this.concat = data.replaceAll("\n", "<br>");
        return this.concat;
      } else {
        let hmsg = body.variableHeader
          ? body.variableHeader
          : body.headerVariable.variableHeaderValue;
        let bmsg = body.format;
        let data = hmsg + "\n" + bmsg;
        this.concat = data.replaceAll("\n", "<br>");
        return this.concat;
      }

      // let dataString = hmsg + "\n" + bmsg;
      // this.concat = dataString.replaceAll("\n", "<br>");
    },
    async getAllTemplate() {
      this.data = await this.$store.dispatch("whatsApp/getAllTemplate");
    },
    async getAllvariables() {
      try {
        let data = await this.$store.dispatch("variable/getAllDropDown", {
          isDeleted: false,
        });
        this.variableValues = data.data;
      } catch (err) {
        console.log(err);
      }
    },
    async getAllConfigs() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.projectName,
        projectId: this.selectedProject._id,
      };
      let { data } = await axios.post(
        // "http://localhost:3001/api/marcom/whatsapp/getWhatsappConfig",
        process.env.VUE_APP_BASE_API + "/marcom/whatsapp/getWhatsappConfig",
        payload,
        {
          headers: {
            "community-name": process.env.VUE_APP_COMMUNITY_NAME,
          },
        }
      );

      // console.log(data);
      this.options = data.data;

      this.verifyClick(true);
    },

    whitespaceRemove() {
      this.$el.addEventListener("input", () => {
        this.input = this.input ? this.input.trimStart() : "";
      });
    },
    async getAllmyAddons() {
      let smsAddOns = {};
      for (let i of this.myAddOns) {
        if (i.addOnId.flag == "WA") {
          smsAddOns = i;
        }
      }
      this.myAddonsData = smsAddOns;
    },
  },
  computed: {
    ...mapState("admin", ["myAddOns", "login"]),
    ...mapState("segment", ["segments"]),
    ...mapState("user", ["selectedProject"]),
    ...mapState("marcom", ["taskListUsers"]),
    dateFormat() {
      return moment().format("ddd, MMMM DD");
    },
    timeFormat() {
      return moment().format("HH:mm a");
    },
  },
  watch: {
    value1(val) {
      if (val == "Create Sender Id") {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    value(val) {
      if (val) {
        let data = [];
        for (let i = 0; i < this.value.length; i++) {
          for (let j = 0; j < this.value[i].audienceId.length; j++) {
            data.push({
              _id: this.value[i].audienceId[j]._id,
              mobile: this.value[i].audienceId[j].mobile
                ? this.value[i].audienceId[j].mobile
                : this.value[i].audienceId[j].contact,
            });
          }
        }

        this.count = data.length;
      }
    },
    input(val) {
      this.whitespaceRemove();
    },
    segmentData(val) {
      if (val.length !== this.segments.length) {
        this.getAllSegments();
      }
    },
    smsbody(val) {
      this.Replacer(this.smsbody);
      if (val && this.smsbody.variableType == true) {
        this.editableBody = this.smsbody.format.replaceAll("\n", "<br>");
        this.editableHeader = this.smsbody.headerVariable.variableHeader;
      }
    },
  },
  mounted() {
    this.getAllConfigs();
    this.getAllTemplate();
    this.getAllSegments();
    this.getAllmyAddons();
    this.getAllvariables();
  },
};
</script>

<style lang="scss">
.magnify {
  transform: scale(1.5);
  transition: transform 0.5s;
}
.wid-200px {
  width: 200px !important;
}
.wid-230px {
  width: 230px !important;
}
.tag {
  p {
    text-align: start !important;
  }

  .txt-center {
    text-align: center !important;
  }
  .shop {
    border-top: 1px solid #8080801f;
    padding: 6px 0;
  }

  .text-primary {
    color: #cd3197 !important;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
